module.exports = __webpack_public_path__ + "d95d6f5d5ab7cfefd09651800b69bd54.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/font-awesome/fonts/fontawesome-webfont.woff?v=4.2.0
 ** module id = 19
 ** module chunks = 0
 **/